import React, { useState } from 'react';
import puter from '@heyputer/puter.js';
import '../css/Chatbot.css';

export function Chatbot() {
    const [messages, setMessages] = useState([]);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!query.trim()) return;

        // Add user message
        setMessages((prev) => [...prev, { type: "user", text: query }]);
        setQuery("");
        //await callAzureOpenAI();
        await callPuter();
    };

    async function callPuter() {
        setLoading(true);
        try {
            // Call Puter AI
            const response = await puter.ai.chat(query);

            setMessages((prev) => [
                ...prev,
                { type: "bot", text: response.message.content },
            ]);
        } catch (error) {
            setMessages((prev) => [
                ...prev,
                { type: "bot", text: "Error: Unable to fetch response." },
            ]);
        } finally {
            setLoading(false);
        }
    }

    async function callAzureOpenAI() {
        setLoading(true);
        try {
            const response = await fetch('api/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(query)
            });
            if (response.ok) {
                const chatResponse = await response.text();
                setLoading(false);
                setMessages((prev) => [
                    ...prev,
                    { type: "bot", text: chatResponse },
                ]);
            }
        } catch (error) {
            setMessages((prev) => [
                ...prev,
                { type: "bot", text: "Error: Unable to fetch response." },
            ]);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="container chat-container shadow-lg rounded d-flex flex-column" style={{ height: "90vh" }}>
            {/* Chat Header */}
            <div className="p-3 bg-primary text-white rounded-top">
                <h5>Ask me anything</h5>
            </div>

            {/* Message Area */}
            <div className="message-area d-flex flex-column flex-grow-1 overflow-auto p-3 bg-light">
                {messages.map((msg, idx) => (
                    <div
                        key={idx}
                        className={
                            msg.type === "user"
                                ? "message-bubble-user ms-auto"
                                : "message-bubble-other"
                        }
                    >
                        {msg.text}
                    </div>
                ))}
                {loading && (
                    <div className="loading-bubble">Thinking...</div>
                )}
            </div>

            {/* Input Area */}
            <div className="message-input-area rounded-bottom p-3 bg-white border-top">
                <form className="d-flex" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        className="form-control me-2"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Type your query..."
                    />
                    <button type="submit" className="btn btn-primary">
                        Send
                    </button>
                </form>
            </div>
        </div>
    );
}
